import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Container from '../Container';

import {
  container,
  footer,
} from './styles.module.css';

const DiscoverFooter = ({ locations }) => (
  <footer className={footer}>
    <Container className={container}>
      <ul>
        {locations.map(location => (
          <li key={location.name}>
            <Link
              to={`/${location.iso2.toLowerCase()}/all-events/in-${location.slug}`}
            >
              <span>
                All events in {location.name}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </Container>
  </footer>
);


DiscoverFooter.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
};

const mapStateToProps = state => ({
  locations: state.locations,
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const DiscoveryFooterWithRedux = connect(mapStateToProps)(DiscoverFooter);
export default DiscoveryFooterWithRedux;



// WEBPACK FOOTER //
// ./app/src/components/DiscoverFooter/index.jsx